import React from 'react';
import { Loading } from 'pages/App/components/Loading';
import { useFirestoreCollectionData, SuspenseWithPerf } from 'reactfire';
import { Grid } from 'semantic-ui-react';
import { useHistoryHook } from 'services/hooks/useHistoryHook'
import HistoryItems from '../Items'

function HistoryContentUserCore({ uid, oid }: any) {

  const { collections: { historyByUser } } = useHistoryHook(oid);

  const historyData = useFirestoreCollectionData(historyByUser(uid))

  return (
    <>
      <Grid.Row>
        <HistoryItems oid={oid} historyData={historyData} />
      </Grid.Row>
    </>
  );
}

function HistoryContentUser(props: any) {
  return (
    <SuspenseWithPerf
      fallback={<Loading />}
      traceId={`howwee-history-${props.oid || ''}-${props.uid || ''}`}
    >
      <HistoryContentUserCore {...props} />
    </SuspenseWithPerf>
  )
}

export default HistoryContentUser;